import { render } from "./UserSettingsDropdown.vue?vue&type=template&id=52a1f722&scoped=true"
import script from "./UserSettingsDropdown.vue?vue&type=script&lang=js"
export * from "./UserSettingsDropdown.vue?vue&type=script&lang=js"

import "./UserSettingsDropdown.vue?vue&type=style&index=0&id=52a1f722&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-52a1f722"

export default script